<template>
  <div class="sv sv016">
    <div class="container">
      <BreadcrumbGroup :items="breadcrumbItems" />

      <ContentsHeader class="-orange" src="sv016/main.jpg">
        <p class="heading1">auサービスでもっとおトクに！</p>
        <h1 class="heading2">Pontaポイントで<br />スマートな暮らしを！</h1>
      </ContentsHeader>
    </div>

    <div class="container">
      <ContentsIntro
        class="-orange _pt-sm-50"
        icon-left="sv016/avatar-a.gif"
        name-left="Aさん"
        icon-right="sv016/avatar-b.gif"
        name-right="Bさん"
        txt-relation="同僚の2人"
      >
        友達の多いBさんは、毎月の生活費の中で交際費が占める割合が多いのが悩み。<br />
        やりくり上手のAさんがPontaポイントの活用方法について教えてくれるようで…。
      </ContentsIntro>
    </div>

    <hr class="-pcnone _mb-sm-60" />

    <div class="container">
      <HeadingTwo class="_mt-md-110 _mt-sm-60"
        >Pontaポイントでお買い物やお支払いがおトクに！</HeadingTwo
      >

      <TalkGroup class="_mb-md-60 _mb-sm-40">
        <TalkBox src="sv016/avatar-b.gif"
          >今月は友達とたくさん遊ぶ予定を入れちゃった！お財布ピンチだしランチ代をきりつめようかな…賢くやりくりする方法ってないかなあ…</TalkBox
        >
        <TalkBox src="sv016/avatar-a.gif"
          >毎日楽しそうだけど出費がかさむのは痛いね。そういえばBさんって、auユーザーじゃなかったっけ。auのPontaポイントってつかってる？</TalkBox
        >
        <TalkBox src="sv016/avatar-b.gif"
          >スマートフォンの契約したときに聞いたような気がするけど、つかってないなあ</TalkBox
        >
        <TalkBox src="sv016/avatar-a.gif"
          >それはもったいないかも！Pontaポイントはauのポイントで、スマートフォンの利用料をはじめ、いろいろな方法でためることができるポイントなんだ。たまったPontaポイントはauの利用料金の支払いにもつかえるから、生活費が少し楽になると思うよ！</TalkBox
        >
        <TalkBox src="sv016/avatar-b.gif"
          >そうだったの！？毎月のau料金に充当できるならこれからつかってみたいな！</TalkBox
        >
      </TalkGroup>
      <ListGroup class="-note">
        <ListItem class="-note"
          >Pontaポイントを充当できる期間や金額は、お申し込みいただくコースにより異なります。</ListItem
        >
        <a
          href="https://id.auone.jp/id/pc/point/howtouse/index.html?medid=auhp_service&srcid=wpoint&serial=068"
          target="_blank"
          class="-next -link"
          >詳しくはこちら</a
        >
        ＞
      </ListGroup>

      <HeadingTwo class="_mt-md-110 _mt-sm-60"
        >Pontaポイントは、さまざまな方法でためられる！</HeadingTwo
      >

      <TalkGroup src="sv016/img01.jpg" class="_mb-md-60 _mb-sm-40">
        <TalkBox src="sv016/avatar-b.gif"
          >Pontaポイントをためる方法って、他にはどんな方法があるの？</TalkBox
        >
        <TalkBox src="sv016/avatar-a.gif"
          >実は普段のお買い物や、電気料金の支払いでもためることができるんだ！</TalkBox
        >
      </TalkGroup>

      <ContentsCard class="-orange _mb-sm-30">
        <div class="card-header">
          <IconBox src="light-orange" class="-md _mb-sm-10"></IconBox>
          <h3 class="heading -orange">
            Pontaポイントをスマートにためて、暮らしをもっとおトクに！
          </h3>
        </div>
        <div class="card-body01">
          <div class="card-groups">
            <div class="card-box -left">
              <div class="card-image">
                <img
                  src="@/assets/images/sv/sv001/img07.gif"
                  class="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div class="card-box -right">
              <div class="card-body">
                <ListGroup class="-normal">
                  <ListItem class="-normal"
                    >au PAY 残高にチャージして、au PAY プリペイドカードやau
                    PAYとしてお買い物で使うとPontaポイントがたまる！さらに、ポイントアップ店で使えばもらえるPontaポイントがアップ！※</ListItem
                  >
                  <ListItem class="-normal"
                    >au携帯電話、固定通信サービスの利用でためる！</ListItem
                  >
                  <ListItem class="-normal"
                    >「au でんき」は、au スマホやau
                    ひかりとセットで電気の利用量に応じてPontaポイントがたまる！</ListItem
                  >
                </ListGroup>
                <ListGroup class="-note">
                  <ListItem class="-note"
                    >一部対象外となるサービスや店舗がございます。</ListItem
                  >
                  <a
                    href="https://id.auone.jp/id/pc/point/pointup/pointup.html"
                    target="_blank"
                    class="-next -link"
                    >詳しくはこちら</a
                  >
                  ＞
                </ListGroup>
              </div>
            </div>
          </div>
        </div>
      </ContentsCard>

      <TalkGroup class="_mb-md-60 _mb-sm-40">
        <TalkBox src="sv016/avatar-b.gif"
          >こんなにためる場面があったなんて！au PAY
          プリペイドカードならコンビニや飲食店でも使えるから、楽しくためられそう！</TalkBox
        >
      </TalkGroup>

      <HeadingTwo class="_mt-md-110 _mt-sm-60"
        >Pontaポイントは、いろいろな場面でつかえる！</HeadingTwo
      >

      <TalkGroup class="_mb-md-60 _mb-sm-40">
        <TalkBox src="sv016/avatar-b.gif"
          >そういえば、たまったPontaポイントはau料金の支払い以外にはつかえないの？</TalkBox
        >
        <TalkBox src="sv016/avatar-a.gif"
          >そんなことないよ！1Pontaポイント＝1円としてau PAY
          残高にチャージができるんだ。<br />チャージした残高は、au PAY
          プリペイドカードやau
          PAYでコンビニをはじめとした色々なお店で使えるし、お買い物がもっとおトクになるよ！</TalkBox
        >
      </TalkGroup>
      <ListGroup class="-note">
        <ListItem class="-note"
          >一部対象外となるサービスや店舗がございます。</ListItem
        >
        <a
          href="https://www.au.com/payment/point/"
          target="_blank"
          class="-next -link"
          >Pontaポイントについて詳しくはこちら</a
        >
        ＞
      </ListGroup>

      <HeadingTwo class="_mt-md-110 _mt-sm-60"
        >au PAY スマートローンお借り入れ方法は、<br />au PAY
        残高へのチャージがおすすめ！</HeadingTwo
      >

      <TalkGroup class="_mb-md-60 _mb-sm-40">
        <TalkBox src="sv016/avatar-a.gif"
          >Bさんは『au PAY スマートローン』って知ってる？</TalkBox
        >
        <TalkBox src="sv016/avatar-b.gif"
          >auのローンサービスだよね。小額で借りられそうだし、ちょっと使ってみようかなって考えてるよ</TalkBox
        >
        <TalkBox src="sv016/avatar-a.gif"
          >au PAY 残高にチャージして使うのがおすすめなんだよ！</TalkBox
        >
        <TalkBox src="sv016/avatar-b.gif">どうして？</TalkBox>
        <TalkBox src="sv016/avatar-a.gif"
          >現金で借り入れして買い物に使っても、ポイントはたまらないよね？<br />でも、au
          PAY 残高にチャージしてau PAY プリペイドカードやau
          PAYでいつものお買い物に利用すれば200円（税込）ごとに１Pontaポイントたまるんだよ。</TalkBox
        >
        <TalkBox src="sv016/avatar-b.gif"
          >そうか！ランチ代とか生活費として借りる場合は、Pontaポイントもたまっておトクに使えるのね！</TalkBox
        >
        <TalkBox src="sv016/avatar-a.gif"
          >例えば、au PAY スマートローンでau PAY
          残高にチャージして借り入れした場合に、1ヵ月で支払う利息はいくらになると思う？</TalkBox
        >
        <TalkBox src="sv016/avatar-b.gif">うーん、想像できないな…</TalkBox>
      </TalkGroup>

      <ContentsCard class="-orange _mb-sm-30">
        <div class="card-header">
          <IconBox src="light-orange" class="-md _mb-sm-10"></IconBox>
          <h3 class="heading -orange">利息を計算してみよう！</h3>
        </div>
        <div class="card-body02 _pt-md-30">
          <div class="card-groups">
            <div class="card-box">
              <div class="card-body">
                <p class="txt01">
                  例）au PAY スマートローンでau PAY
                  残高にチャージして借り入れした場合に、1ヵ月で支払う利息は？
                </p>
                <div class="triangle"></div>
                <div class="txt-box">
                  <p class="txt02">金利18.0%の場合</p>
                  <p class="txt03">
                    20,000円×18.0%<br class="-pcnone" />÷365日×30日 =
                  </p>
                  <p class="txt04">約295円</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ContentsCard>

      <ListGroup class="-note">
        <ListItem class="-note"
          >お借り入れの当日はご利用日数に含まれません。</ListItem
        >
        <ListItem class="-note"
          >お利息の計算では、1円未満端数切捨てとなります。</ListItem
        >
        <ListItem class="-note"
          >お借り入れ時がうるう年の場合は366日での計算となります。</ListItem
        >
      </ListGroup>
      <TalkGroup class="_mb-md-60 _mb-sm-40">
        <TalkBox src="sv016/avatar-a.gif"
          >金利18.0％で借りた場合、利息は約295円だよ</TalkBox
        >
        <TalkBox src="sv016/avatar-b.gif"
          >えーっと、20,000円・・・ドラックストアでau PAY プリペイドカードやau
          PAYで使った場合は、Pontaポイントが100Pたまるよね・・・</TalkBox
        >
        <TalkBox src="sv016/avatar-a.gif"
          >そうだね！au PAY
          残高にチャージして使えば、現金で借りるよりPontaポイント分がおトクなんだ！</TalkBox
        >
        <TalkBox src="sv016/avatar-b.gif"
          >auのサービスをうまく使うと、賢くやりくりできそう！教えてくれてありがとう！</TalkBox
        >
        <ListGroup class="-note">
          <ListItem class="-note"
            >au PAY
            スマートローンのご契約・ご利用には審査がございます。審査状況によりご希望に添えない場合がございますので、あらかじめご了承ください。</ListItem
          >
        </ListGroup>
      </TalkGroup>

      <div class="container">
        <BtngroupSingle class="_mb-md-60 _mb-sm-40">
          <BtnMain class="-normal -lg" router-name="sv002">
            au PAY スマートローンの特徴について
          </BtnMain>
        </BtngroupSingle>
      </div>
      <ListGroup class="_mb-md-120 _mb-sm-60">
        <ListItem class="normal"
          >au PAY
          スマートローンは、au回線をお持ちでない方でもご利用いただけます。</ListItem
        >
        <ListItem class="normal"
          ><a href="https://loan.kddi-fs.com/apply" class="-next -link"
            >詳しいお申し込み条件はこちら ＞</a
          ></ListItem
        >
      </ListGroup>
      <CvBox class="-cv _mb-md-120 _mb-sm-60" />
    </div>

    <hr class="_mb-120 _mb-sm-60" />

    <div class="container">
      <HeadingTwo>おすすめ記事</HeadingTwo>

      <CardGroups class="-image-top-list">
        <CardBox router-name="sv013" class="-image-top">
          <CardHeader>
            <CardImage class="-orange"
              ><img
                src="@/assets/images/sv/sv013/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">携帯電話の料金を見直しておトクに節約！</h3>
          </CardHeader>
          <CardBody
            >お給料日前は毎月ピンチ…節約を考えるなら、まずは「固定費」を見直してみよう。</CardBody
          >
        </CardBox>
        <CardBox router-name="sv014" class="-image-top">
          <CardHeader>
            <CardImage class="-orange"
              ><img
                src="@/assets/images/sv/sv014/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">
              電気の支払いもauのサービスにまとめるとさらにおトクに！
            </h3>
          </CardHeader>
          <CardBody
            >auユーザーなら『auでんき』に乗り換えるととってもおトクだよ！…</CardBody
          >
        </CardBox>
        <CardBox router-name="sv009" class="-image-top">
          <CardHeader>
            <CardImage class="-green"
              ><img
                src="@/assets/images/sv/sv009/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">ローンにおける金利の仕組みとは？</h3>
          </CardHeader>
          <CardBody
            >「金利・利息・実質年率ってなんだろう？」いまさら聞けないローンのキホンについて！</CardBody
          >
        </CardBox>
      </CardGroups>
    </div>
    <!-- container -->
  </div>
</template>

<script>
import { setMeta } from "@/utils/Meta";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import ContentsHeader from "@/components/contents/ContentsHeader";
import ContentsIntro from "@/components/contents/ContentsIntro";
import HeadingTwo from "@/components/heading/HeadingTwo";
import TalkGroup from "@/components/contents/TalkGroup";
import TalkBox from "@/components/contents/TalkBox";
import ContentsCard from "@/components/contents/ContentsCard";
import IconBox from "@/components/icons/IconBox";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import CvBox from "@/components/box/CvBox";
import CardGroups from "@/components/card/CardGroups";
import CardBox from "@/components/card/CardBox";
import CardHeader from "@/components/card/CardHeader";
import CardImage from "@/components/card/CardImage";
import CardBody from "@/components/card/CardBody";
export default {
  name: "Sv016",
  components: {
    BreadcrumbGroup,
    CardBody,
    CardImage,
    CardHeader,
    CardBox,
    CardGroups,
    CvBox,
    BtnMain,
    BtngroupSingle,
    ListItem,
    ListGroup,
    IconBox,
    ContentsCard,
    TalkBox,
    TalkGroup,
    HeadingTwo,
    ContentsIntro,
    ContentsHeader,
  },
  setup() {
    setMeta({
      title:
        "Pontaポイントでスマートな暮らしを！｜auサービスでもっとおトクに！",
      description:
        "auサービスでおトクに！Pontaポイントを活用したおトクな節約方法について。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,スマート,暮らし",
    });
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "root",
        },
        {
          text: "知っておきたい！ローンについて",
          routerName: "sv003",
        },
        {
          text: "auサービスでもっとおトクに！",
          routerName: "sv044",
        },
        {
          text: "Pontaポイントでスマートな暮らしを！",
          active: true,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.contents-card {
  > .card-body01 {
    background-color: #fff;
    border-radius: 10px;
    padding-top: 30px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 30px;
    @include mq-up(md) {
      padding-left: 50px !important;
      padding-right: 50px !important;
    }
    > .card-groups {
      display: flex;
      @include mq-down(md) {
        flex-wrap: wrap;
      }
      @include mq-up(md) {
        justify-content: space-between;
      }
      > .card-box {
        @include mq-down(md) {
          width: 100%;
        }
        @include mq-up(md) {
          width: 30%;
        }
        &.-left {
          @include mq-up(md) {
            width: 20%;
          }
        }
        &.-right {
          @include mq-up(md) {
            width: 80%;
          }
        }
        > .card-image {
          width: 70%;
          @include mq-down(md) {
            margin: 0 auto 20px;
          }
        }
      }
    }
  }
}

.contents-card {
  > .card-body02 {
    background-color: #fff;
    border-radius: 10px;
    padding-top: 30px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 30px;
    @include mq-up(md) {
      padding-left: 50px !important;
      padding-right: 50px !important;
    }
    > .txt01 {
      font-size: 12px;
      word-break: break-all;
      @include mq-up(md) {
        margin-bottom: 25px;
        font-size: 14px;
      }
    }
    > .card-groups {
      > .card-box {
        > .card-body {
          text-align: center;
          > .txt01 {
            margin-bottom: 30px;
          }
          > .triangle {
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 20px 40px 0 40px;
            border-color: #dddddd transparent transparent transparent;
            margin: 0 auto 10px;
          }
          > .txt-box {
            display: flex;
            @include mq-down(md) {
              flex-direction: column;
            }
            @include mq-up(md) {
              justify-content: center;
              align-items: center;
            }
            .txt02 {
              padding: 5px 0px;
              background-color: $primary;
              font-size: 16px;
              line-height: 24px;
              color: $white;
              border-radius: 10px;
              @include mq-up(md) {
                padding: 5px 15px;
                font-size: 21px;
                line-height: 36px;
              }
            }
            .txt03 {
              margin-left: 25px;
              font-size: 17px;
              line-height: 28px;
              @include mq-up(md) {
                font-size: 21px;
                line-height: 36px;
              }
            }
            .txt04 {
              font-size: 33px;
              line-height: 36px;
              color: $orange;
              font-weight: bold;
              margin-left: 10px;
              @include mq-up(md) {
                font-size: 41px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
